module.exports = __webpack_public_path__ + "media/images/assistant_profile-f91d6c69541dc75cd12371045b1092ed.webp";